import { IFinding, IValidationOutput, IValidator } from "../types";

import { worstSeverity } from "./severity";

/**
 * The output of a validator whose result holds a list of findings: valid when the
 * list is empty, with the worst severity of the list otherwise.
 */
export function createValidationOutput<TOut>(
  validator: Pick<
    IValidator<TOut>,
    "name" | "okTranslationKey" | "errorTranslationKey" | "specialScopes" | "severity" | "stage"
  >,
  findings: IFinding[],
  result: TOut,
): IValidationOutput<TOut> {
  const isValid = findings.length === 0;

  return {
    name: validator.name,
    isValid,
    messageTranslationKey: isValid ? validator.okTranslationKey : validator.errorTranslationKey,
    specialScopes: validator.specialScopes,
    severity: worstSeverity(findings, validator.severity ?? "error"),
    stage: validator.stage ?? "semantic",
    result,
  };
}
